import React, {FC} from 'react'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'

//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKGrid from 'shared/LKGrid'

import { translateCmd } from '../../helpers'
import { formName } from '../../constants'

import { InsurancesProps } from '../../types'

const config = {
  gridIdentity: { formName, objectName: 'dbgrd_insurance' },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    InsuranceDate: { valueFormatter: ({ value }) => dateFormatter(value) },
    InsuranceExpire: { valueFormatter: ({ value }) => dateFormatter(value) },
    InsuranceAmount: { cellStyle: { textAlign: 'right' } },
  },

  getContextMenuItems: () => [
    { name: translateCmd('edit_insurance'), action: () => {}, icon: 'edit' },
    { name: translateCmd('delete_insurance'), action: () => {}, icon: 'delete' },
  ],
}

const Insurances: FC<InsurancesProps> = ({ data, instanceName }) => (
  <div className="u-flex u-fluid u-directionColumn">
    <div className="u-fluid u-relative">
      <LKGrid rowData={data} {...config} instanceName={instanceName} />
    </div>

    <div className="u-padding-5">
      <LKButton alias="insurance_add" size="tiny">
        {translateCmd('add_insurance')}
      </LKButton>
    </div>
  </div>
)

Insurances.defaultProps = {
  data: [],
}

export default React.memo(Insurances)
